/* eslint-disable jira/filename-case */

import type { TailoredOnboardingTeamType } from '@jira/growth__tailored-onboarding/src/TailoredOnboardingTailoredTeamType.types.tsx';
import {
	USER_SEGMENTATION_TEAM_TYPE_DESIGN,
	USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT,
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_OPERATIONS,
	USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL,
	USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
} from '@jira/platform__onboarding-core/src/constants.tsx';

export const TeamType: {
	readonly productManagement: 'teamType.PDM';
	readonly projectManagement: 'teamType.PJM';
	readonly design: 'teamType.DES';
	readonly itSupport: 'teamType.ITS';
	readonly otherPersonal: 'teamType.OTR';
	readonly marketing: 'teamType.MKT';
	readonly operations: 'teamType.OPS';
	readonly software: 'teamType.DEV';
	// Fallback team type config used for team types we aren't catering for e.g. Data science
	// and also used if the team type is unexpected/unknown
	readonly everythingElse: 'teamType.everythingElse';
} = {
	productManagement: `teamType.${USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT}`,
	projectManagement: `teamType.${USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT}`,
	design: `teamType.${USER_SEGMENTATION_TEAM_TYPE_DESIGN}`,
	itSupport: `teamType.${USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT}`,
	otherPersonal: `teamType.${USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL}`,
	marketing: `teamType.${USER_SEGMENTATION_TEAM_TYPE_MARKETING}`,
	operations: `teamType.${USER_SEGMENTATION_TEAM_TYPE_OPERATIONS}`,
	software: `teamType.${USER_SEGMENTATION_TEAM_TYPE_SOFTWARE}`,
	// Fallback team type config used for team types we aren't catering for e.g. Data science
	// and also used if the team type is unexpected/unknown
	everythingElse: 'teamType.everythingElse',
} as const satisfies Record<string, `teamType.${TailoredOnboardingTeamType}`>;

export const Feature = {
	hasBacklog: 'feature.hasBacklog',
	hasSprint: 'feature.hasSprint',
	hasSummaryPage: 'feature.hasSummaryPage',
	hasRoadmap: 'feature.hasRoadmap',
	hasList: 'feature.hasList',
	hasCalendar: 'feature.hasCalendar',
	hasCode: 'feature.hasCode',
	hasForms: 'feature.hasForms',
	hasPages: 'feature.hasPages',
	hasPlanDependencies: 'feature.hasPlanDependencies',
	hasPlanProgram: 'feature.hasPlanProgram',
	hasPlanReleases: 'feature.hasPlanReleases',
	hasPlanTeams: 'feature.hasPlanTeams',
} as const;

export const FeatureGate = {
	removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name',
} as const;

export const Permissions = {
	canCreateIssue: 'permissions.canCreateIssue',
} as const;

export const Experiment = {
	scrumOnboarding: 'experiment.scrumOnboarding',
	tailoredOnboardingScrumAndSoftwareKanbanEligible:
		'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible',
} as const;

export const Experience = {
	fedRamp: 'experience.fedRamp',
} as const;
